export default class NavigationMenuItem {
    path: string;
    text: string;
    icon: string;
    constructor(path: string, text: string, icon: string){
        this.path = path;
        this.text = text;
        this.icon = icon;
    }
}